//
// Generated class DocumentLink
//

/// <reference path="DocumentLink_ManagedObject.ts" />

class DocumentLink extends DocumentLink_ManagedObject
{

}
